const PlanTypes = [
  { text: "ESOP", value: "ESOP" },
  { text: "Stock Appreciation Rights", value: "SAR" },
  { text: "Restricted Stock Units", value: "RSU" },
  { text: "TRUST", value: "TRUST" },
];
export default PlanTypes;
